export default class Carousel {
    constructor({ el }) {
        this.el = el;
        this.figures = el.querySelectorAll("figure");
        this.timelines = [];

        this.setupTimelines();
        this.initialize();
        this.setupScrollTriggers();
    }

    setupTimelines() {
        const radius = window.innerWidth;
        const offsetY = -(radius - window.innerHeight);
        const isMobile = window.innerWidth < 768;
        const duration = window.innerWidth / (isMobile ? 75 : 150);

        const totalFigures = this.figures.length || 1;
        const delayFactor = 10.5 / totalFigures;

        gsap.set(this.figures, { 
            transformOrigin: `${radius}px ${offsetY}px`,  
            rotation: 90 
        });

        let maxZIndex = this.figures.length;

        this.figures.forEach((figure, i) => {
            const img = figure.querySelector("img");
            if (!img) return;
            const randomizeElement = () => {
                maxZIndex++;
                gsap.set(figure, { zIndex: maxZIndex });

                const randomY = 400 * Math.random() - 200;
                gsap.set(img, { y: randomY });
            };

            const timeline = gsap.timeline({ 
                repeat: -1, 
                delay: -i * delayFactor, 
                immediateRender: true,
                onStart: randomizeElement,
                onRepeat: randomizeElement
            });

            timeline
                .set(img, { scale: 0.2 })
                .fromTo(figure, { rotation: -10 }, { rotation: -100, ease: "linear", duration }, 'a')
                .fromTo(img, { rotation: 10 }, { rotation: 100, ease: "linear", duration }, 'a')
                .fromTo(img, { scale: 0.2 }, { scale: 1, ease: "power1.out", duration: duration * 0.15 }, `a+=${duration * 0.25}`)
                .fromTo(img, { scale: 1 }, { scale: 0.2, ease: "power1.in", duration: duration * 0.15 }, `a+=${duration * 0.4}`);

            this.timelines.push(timeline);
        });
    }

    setupScrollTriggers() {
        const isMobile = window.innerWidth < 768;

        this.pinST = ScrollTrigger.create({
            trigger: this.el,
            start: 'top top',
            pin: true,
            end: isMobile ? '+=0%' : '+=50%'
        });

        this.scrollST = ScrollTrigger.create({
            trigger: this.el.parentElement,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            onUpdate: (self) => {
                const veloce = Math.abs(self.getVelocity()) / window.innerHeight * 2;
                this.timelines.forEach(timeline => {
                    gsap.to(timeline, { timeScale: 1 + veloce, duration: 0.1, overwrite: "auto" });
                });
            },
            onScrollEnd: () => {
                this.timelines.forEach(timeline => {
                    gsap.to(timeline, { timeScale: 1, duration: 0.5, ease: "power1.out", overwrite: "auto" });
                });
            }
        });

        requestAnimationFrame(() => {
            ScrollTrigger.refresh();
        });
    }

    handleResize() {
        const isMobile = window.innerWidth < 768;
        const radius = isMobile ? window.innerHeight : window.innerWidth;
        const offsetY = Math.min(0, -(radius - window.innerHeight));

        gsap.set(this.figures, { transformOrigin: `${radius}px ${offsetY}px` });
    }

    initialize() {
        this.boundResize = this.handleResize.bind(this);
        window.addEventListener("resize", this.boundResize);
        this.handleResize();
    }

    dispose() {
        window.removeEventListener("resize", this.boundResize);
        
        if (this.pinST) this.pinST.kill();
        if (this.scrollST) this.scrollST.kill();

        this.timelines.forEach(timeline => timeline.kill());
    }
}